export default "__VITE_ASSET__6f01c100__"